import { AxiosInstance } from 'axios'

import {
  iamDefaultApiFactory,
  userApiDefaultApiFactory,
} from '@src/api/default-api-factories'
import {
  DefaultApiUpdateUserPasswordRequest,
  DefaultApiUpdateUserTempPasswordRequest,
  DefaultApiUsersPasswordResetCheckGetRequest,
  DefaultApiUsersPasswordResetConfirmPostRequest,
  DefaultApiUsersPasswordResetPostRequest,
  DefaultApiUsersPasswordResetTfaSmsVerifyPostRequest,
  DefaultApiUsersPasswordResetTfaAppVerifyPostRequest,
  DefaultApiUsersPasswordResetTfaRecoveryCodePostRequest,
} from '@src/api/generated/iam'
import {
  UsersEmailConfirmRequest,
  UpdateUserEmailRequest,
  UpdateUserNameRequest,
  DefaultApiGetCanDeactivateRequest,
  DefaultApiDeactivateUserRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const emailConfirm = async (
  instance: AxiosInstance,
  params: UsersEmailConfirmRequest
) => {
  return await userApiDefaultApiFactory(instance).usersEmailConfirm({
    usersEmailConfirmRequest: params,
  })
}

export const getAdmins = async (
  instance: AxiosInstance,
  { organizationId }: { organizationId: string }
) => {
  return userApiDefaultApiFactory(instance).getAdmins({ organizationId })
}

export const getBookkeepers = async (
  instance: AxiosInstance,
  { organizationId }: { organizationId: string }
) => {
  return userApiDefaultApiFactory(instance).getBookkeepers({ organizationId })
}

export const getUserMe = async (instance: AxiosInstance) => {
  return userApiDefaultApiFactory(instance).getUsersMe()
}

export const getUsers = async (
  instance: AxiosInstance,
  { organizationId }: { organizationId: string }
) => {
  return userApiDefaultApiFactory(instance).getUsers({ organizationId })
}

export const updateUserEmail = async (
  instance: AxiosInstance,
  userId: string,
  params: UpdateUserEmailRequest
) => {
  return await userApiDefaultApiFactory(instance).updateUserEmail({
    updateUserEmailRequest: params,
    userId,
  })
}

export const updateUserName = async (
  instance: AxiosInstance,
  userId: string,
  params: UpdateUserNameRequest
) => {
  return await userApiDefaultApiFactory(instance).updateUserName({
    updateUserNameRequest: params,
    userId,
  })
}

export const updateUserPassword = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateUserPasswordRequest
) => {
  return await iamDefaultApiFactory(instance).updateUserPassword(params)
}

export const getCanDeactivate = async (
  instance: AxiosInstance,
  params: DefaultApiGetCanDeactivateRequest
) => {
  return await userApiDefaultApiFactory(instance).getCanDeactivate(params)
}

export const deactivateUser = async (
  instance: AxiosInstance,
  params: DefaultApiDeactivateUserRequest
) => {
  return await userApiDefaultApiFactory(instance).deactivateUser(params)
}

export const usersPasswordResetCheckGet = async (
  instance: AxiosInstance,
  params: DefaultApiUsersPasswordResetCheckGetRequest
) => {
  return await iamDefaultApiFactory(instance).usersPasswordResetCheckGet(params)
}

export const usersPasswordResetConfirmPost = async (
  instance: AxiosInstance,
  params: DefaultApiUsersPasswordResetConfirmPostRequest
) => {
  return await iamDefaultApiFactory(instance).usersPasswordResetConfirmPost(
    params
  )
}

export const usersPasswordResetTfaSmsVerifyPost = async (
  instance: AxiosInstance,
  params: DefaultApiUsersPasswordResetTfaSmsVerifyPostRequest
) => {
  return await iamDefaultApiFactory(
    instance
  ).usersPasswordResetTfaSmsVerifyPost(params)
}

export const usersPasswordResetPost = async (
  instance: AxiosInstance,
  params: DefaultApiUsersPasswordResetPostRequest
) => {
  return await iamDefaultApiFactory(instance).usersPasswordResetPost(params)
}

export const updateUserTempPassword = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateUserTempPasswordRequest
) => {
  return await iamDefaultApiFactory(instance).updateUserTempPassword(params)
}

export const usersPasswordResetTfaAppVerifyPost = async (
  instance: AxiosInstance,
  params: DefaultApiUsersPasswordResetTfaAppVerifyPostRequest
) => {
  return await iamDefaultApiFactory(
    instance
  ).usersPasswordResetTfaAppVerifyPost(params)
}

export const usersPasswordResetTfaRecoveryCodePost = async (
  instance: AxiosInstance,
  params: DefaultApiUsersPasswordResetTfaRecoveryCodePostRequest
) => {
  return await iamDefaultApiFactory(
    instance
  ).usersPasswordResetTfaRecoveryCodePost(params)
}

// Do Not Remove this line ===@import api client===
